export const PasswordResetAttempt = 'PasswordResetAttempt'
export const PasswordResetFail = 'PasswordResetFail'
export const PasswordResetSent = 'PasswordResetSent'
export const PasswordResetSuccess = 'PasswordResetSuccess'

export const getPasswordResetFailLabel = () => 'error=internalError'
